// external
import { nanoid } from 'nanoid';

// interstate
import type { ComboBoxOptions } from '@interstate/components/ComboBox';

// types
import type { DiscountOption, DealerDiscount } from '../dealerDiscounts/discountTypes';

export const isBlank = (s: unknown): boolean => {
    if (s == null) return true;
    if (typeof s === 'number') return String(s).trim() === '';
    if (typeof s !== 'string') return false;
    return s.trim() === '';
};

export const isSingleEmptyRowUtil = (discounts: DealerDiscount[]) =>
    discounts.length === 1 && isBlank(discounts[0].discountName) && isBlank(discounts[0].discountAmount);

export const getNonEmptyDiscountsUtil = (discounts: DealerDiscount[]) =>
    discounts.filter((d) => !isBlank(d.discountName) || !isBlank(d.discountAmount));

export const isValidName = (val: unknown): boolean => {
    return typeof val === 'string' && val.trim() !== '';
};

export const isValidAmount = (val: unknown): boolean => {
    if (typeof val === 'string') return val.trim() !== '';
    if (typeof val === 'number') return true;
    return false;
};

export function extractDiscountOption(
    value: string | ComboBoxOptions | undefined,
    fallback?: DiscountOption
): DiscountOption | undefined {
    if (typeof value === 'string') {
        return value ? { label: value, value: value } : undefined;
    }
    if (Array.isArray(value) && value[0]?.label) {
        const label = value[0].label.trim();
        return label ? { label, value: value[0].value } : fallback;
    }
    return fallback;
}

export const mapDealerDiscountValuesToOptions = (dealerDiscountValues: any[]): DiscountOption[] => {
    return dealerDiscountValues.map((discountItem: any) => ({
        'data-testid': discountItem._id ?? nanoid(),
        groupHeader: false,
        label: discountItem.discountName,
        value: String(discountItem.discountAmount)
    }));
};

export const mapToTemporaryDealerDiscounts = (inputData: any[]): DealerDiscount[] => {
    return inputData.map((item) => ({
        id: nanoid(),
        discountName: String(item.discountName ?? ''),
        discountAmount: String(item.discountAmount ?? ''),
        selected: item.selected ?? true,
        isCustomDiscount: item.isCustomDiscount ?? false
    }));
};
